<script>
import {
  required,
} from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { notify } from '@/helpers/notify'


export default {
  page: {
    title: "Ayarlar",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "AYARLAR",
      form:{
        new_password:''
      },
      submitted:false,
      items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "AYARLAR LİSTESİ",
          active: true,
        },
      ],
    };
  },
    validations: {
        form:{
            old_password: { required },
            new_password: { required },
        }
    },
  methods:{
    portalTransaction() {
      this.submitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
          return;
      } else {

        this.$http.post('/me/passwordChange', this.form)
            .then(response => {

              if(response.data.error){
                  return notify.error(response.data.message)
              }

              const userdata = JSON.parse(localStorage.getItem('userdata'))


              localStorage.setItem('userdata', JSON.stringify( { ...userdata,password_change : null }))

              return notify.success(response.data.message)

            })
      }
      this.submitted = false;
    },
    generatePassword() {
      const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
      const numbers = "0123456789";
      const specialCharacters = "!@#$%^&*()_-+=<>?/{}";

      // Şifreyi oluştur
      const randomUppercase = uppercaseLetters[Math.floor(Math.random() * uppercaseLetters.length)];
      const randomLowercase = lowercaseLetters[Math.floor(Math.random() * lowercaseLetters.length)];
      const randomNumber = numbers[Math.floor(Math.random() * numbers.length)];
      const randomSpecialCharacter = specialCharacters[Math.floor(Math.random() * specialCharacters.length)];

      const remainingLength = 8 - (randomUppercase.length + randomLowercase.length + randomNumber.length + randomSpecialCharacter.length);


      const randomChars = Array.from({ length: remainingLength }, () => {
        const allChars = uppercaseLetters + lowercaseLetters + numbers + specialCharacters;
        return allChars[Math.floor(Math.random() * allChars.length)];
      });

      // Şifreyi oluşturulan parçaları birleştirerek ayarla
      this.form.new_password = randomUppercase + randomLowercase + randomNumber + randomSpecialCharacter + randomChars.join("");
    },
  },
  mounted(){

  },
};
</script>

<template>
<Layout>
  <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
      <router-view />
      </div>
    </div>
  </Layout>
</template>